<template>
	<footer>
		<div class="foot-nav-container pc_padding">
			<div class="footer-about">
				<div class="footer-item-title">
					<img
						src="@/assets/banner-img.svg"
						alt="" />
				</div>
				<div class="footer-item-content">AI World conact you</div>
			</div>
			<div class="footer-side-row">
				<div class="footer-side-resource">
					<div class="footer-item-content resource">
						<router-link to="/">
							<div class="footer-item-content-item cursor">Evolonik AI</div>
						</router-link>
						<router-link to="/pricing">
							<div class="footer-item-content-item cursor">Pricing</div>
						</router-link>
					</div>
					<div class="footer-item-content resource">
						<router-link to="/privacy">
							<div class="footer-item-content-item cursor">Privacy Policy</div>
						</router-link>
						<router-link to="/terms">
							<div class="footer-item-content-item cursor">Terms of Service</div>
						</router-link>
						<router-link to="/disclaimer">
							<div class="footer-item-content-item cursor">Disclaimer</div>
						</router-link>
					</div>
				</div>
			</div>
		</div>
		<div class="corner-module pc_padding">&copy; Evolonik 2025. All Rights Reserved.</div>
	</footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'FootModule1',
	computed: {
		...mapGetters({
			host: 'host',
			deviceType: 'deviceType',
		}),
	},
	methods: {
		goto(where) {
			console.log(this.$route.path)
			this.$router.push({ name: where })
		},
	},
}
</script>
